import T from 'prop-types';
import React from 'react';
import { Select } from '@acast/decibel';
import Field from 'shared/components/field';

const TypeField = ({ value, onChange }) => (
  <Field label="Media Type" name="type">
    <Select value={value} onChange={event => onChange(event.target.value)}>
      <Select.Option value="Link">Link</Select.Option>
      <Select.Option value="Image">Image</Select.Option>
      <Select.Option value="Video">Video</Select.Option>
    </Select>
  </Field>
);

TypeField.propTypes = {
  onChange: T.func.isRequired,
  value: T.string.isRequired,
};

export default TypeField;
